import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  details: {
    marginTop: 8,
    width: '100%'
  },
  statusRow: {
    marginLeft: 8
  },
  price: {
    marginTop: 16,
    width: '100%'
  },
  statusColumn: {
    marginLeft: 24
  },

  status: {
    marginTop: 4
  },
  button: {
    marginLeft: 24,
    height: 16,
    width: 104,
    padding: '12px 8px'
  },
  buttonBorder: {
    marginLeft: 24,
    height: 16,
    width: 108,
    padding: '10px 6px'
  },

  imgRow: {
    width: '100%',
    marginTop: 16
  }
})
